var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#3284FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1392 16.1816C32.7644 16.1816 32.4594 16.4866 32.4594 16.8614C32.4594 17.2362 32.7644 17.5412 33.1392 17.5412C33.514 17.5412 33.8189 17.2362 33.8189 16.8614C33.8189 16.4866 33.514 16.1816 33.1392 16.1816ZM25 18.9743C21.6771 18.9743 18.9736 21.6777 18.9736 25.0006C18.9736 28.3235 21.6771 31.027 25 31.027C28.323 31.027 31.0264 28.3236 31.0264 25.0007C31.0264 21.6777 28.323 18.9743 25 18.9743Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3242 11H18.6758C14.4433 11 11 14.4433 11 18.6758V31.3242C11 35.5567 14.4433 39 18.6758 39H31.3242C35.5567 39 39 35.5567 39 31.3242V18.6758C39 14.4433 35.5567 11 31.3242 11ZM25 32.6799C20.7653 32.6799 17.3202 29.2347 17.3202 25C17.3202 20.7653 20.7653 17.3202 25 17.3202C29.2347 17.3202 32.6799 20.7653 32.6799 25C32.6799 29.2347 29.2347 32.6799 25 32.6799ZM33.1392 19.1942C31.8526 19.1942 30.8059 18.1474 30.8059 16.8609C30.8059 15.5743 31.8526 14.5275 33.1392 14.5275C34.4258 14.5275 35.4725 15.5742 35.4725 16.8608C35.4725 18.1474 34.4258 19.1942 33.1392 19.1942Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic-instagram.41da82c05a5b97067a64883ea1343c98.svg";
export { ForwardRef as ReactComponent };